import { SwitchProjectComponent } from "./switch-project.component";
import { NgModule } from "@angular/core";
import { DemoMaterialModule } from "../../../demo-material-module";
import { PerfectScrollbarModule, PerfectScrollbarConfigInterface, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    wheelPropagation: false,
};

@NgModule({
    imports: [
        DemoMaterialModule,
        PerfectScrollbarModule
    ],
    declarations: [
        SwitchProjectComponent
    ],
    exports: [
        SwitchProjectComponent
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ]
})
export class SwitchProjectModule { }
